<template>
	<div class="prog_reg-body theme-light">
		<div class="container">
			<div class="title">
				Общая информация
			</div>
			<div class="description">
				<p>Необходимая для регистрации информация об участнике и контактные данные</p>
			</div>
		</div>

		<div class="container">
			<b-card no-body class="mb-2">
				<b-card-header header-tag="header" class="p-0" role="tab">
					<div
						v-b-toggle.collapse-card_0
						class="accordeon-participant-pane"
					>
						#1 Карточка участника
					</div>
				</b-card-header>
				<b-collapse id="collapse-card_0" class visible role="tabpanel">
					<b-card-body>
						<b-form>
							<div v-if="formData.fields" class="row">
								<base-field
									v-for="field in formData.fields[2]"
									:key="field.field_id"
									ref="baseFields"
									:field="field"
									:person-number="1"
									:form-data="formData"
									@blur="onBlur"
								/>
							</div>
						</b-form>

						<b-form-group id="example-input-group-6" class="mt-0 mb-0">
							<b-form-checkbox
								v-model="isRegistrant"
								switch
								:class="{ 'is-invalid': showRegistrantError }"
								class="mt-2 pb-1"
								@change="setRegistrantStatus"
							>
								Я только помогаю зарегистрироваться, но прошу всю переписку вести со мной и присылать
								мне уведомления
							</b-form-checkbox>
							<b-form-invalid-feedback
								id="input-1-live-feedback">
								Если вы помогаете зарегистрироваться, то необходимо добавить участника, которому вы
								помогаете.
							</b-form-invalid-feedback>
						</b-form-group>
						<b-form-group
							v-if="showLoyaltyCheckbox"
							id="example-input-group-6"
							class="mt-0 mb-0"
						>
							<b-form-checkbox
								v-model="needRegisterLoyalty"
								switch
								class="mt-2 pb-1"
								@change="setLoyalty"
							>
								{{ $t('agreeWithLoyalty') }}
								<a target="_blank" href="https://sk.skolkovo.ru/storage/loyalty-legal.pdf">
									{{ $t('loyaltyLegal') }}
								</a>
							</b-form-checkbox>
						</b-form-group>
					</b-card-body>
				</b-collapse>
			</b-card>

			<div v-if="formData.id && getAdditionalPersonsCount(formData.id) > 0">
				<step2-person-field-group
					v-for="n in getAdditionalPersonsCount(formData.id)"
					ref="personGroups"
					:key="n"
					:person-number="n + 1"
					:form-data="formData"
					:current-step="currentStep"
				/>
			</div>
		</div>

		<div class="container mt-4">
			<div class="row">
				<div class="col-12 col-md-6 col-lg-6">
					<div
						v-b-popover.hover.top="'Вы можете оформить и оплатить программу для коллеги'"
						title="Добавить участника"
						class="btn btn-block btn-outline-primary btn-icon icon-plus mb-3"
						@click="addNewPerson"
					>
						Добавить ещё участника
					</div>
				</div>
				<div class="col-12 col-md-6 col-lg-6">
					<input
						ref="file"
						type="file"
						style="display: none;"
						@change="massUpload"
					>
					<div
						class="btn btn-block btn-outline-primary btn-icon icon-download mb-3"
						@click="$refs.file.click()"
					>
						<div v-if="isMassUploading">
							<b-spinner variant="primary" label="Spinning" />
						</div>
						<div v-if="!isMassUploading">
							Загрузить файл участников
						</div>
					</div>
					<div class="description text-muted">
						Для автоматической множественной загрузки участников скачайте
						<a
							:href="baseApiUrl + '/api/checkout/download-example-excel?formId=' + formData.id"
						>
							шаблон (xls)
						</a> и заполните необходимые днные.
					</div>
				</div>
			</div>
		</div>
		<b-modal id="registrant-disclaimer">
			<template #modal-title>
				Внимание
			</template>
			<div class="d-block text-center">
				<p>
					Все последующие данные будут запрашиваться только в отношении будущего студента (на которого будет
					оформлен договор).
				</p>
			</div>
			<template #modal-footer="{ ok }">
				<b-button size="sm" variant="success" @click="ok()">
					OK
				</b-button>
			</template>
		</b-modal>
		<b-modal id="mass-upload-message">
			<div class="d-block text-center">
				<p>{{ massUploadMessage }}</p>
			</div>
			<template #modal-footer="{ ok }">
				<b-button size="sm" variant="success" @click="ok()">
					OK
				</b-button>
			</template>
		</b-modal>
		<b-modal id="signer-warning">
			<template #modal-title>
				Внимание
			</template>
			<div class="d-block text-center">
				<p>
					Чтобы продолжить, необходимо выбрать лицо, от имени которого будет подписан договор
				</p>
			</div>
			<template #modal-footer="{ ok }">
				<b-button size="sm" variant="success">
					OK
				</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import {
	ACTION_GET_PRICE_DATA,
	ACTION_SAVE_FORM_DATA_BACKEND, ACTION_SYNC_FROM_BACKEND,
	CHECKOUT_STORE_NAMESPACE,
	MUTATION_SET_FORM_META_DATA,
} from '~/store/checkout';
import BaseField from '~/components/checkout/CheckoutBaseField.vue';
import Step2PersonFieldGroup from '~/components/checkout/Step2PersonFieldGroup.vue';
import checkoutFormStep from '~/mixins/checkoutFormStep';

export default {
	name: 'CheckoutStep2',
	components: {
		BaseField,
		Step2PersonFieldGroup,
	},
	mixins: [checkoutFormStep],
	props: {
		event: { type: Object, default: null },
		eventFormScenario: { type: String, default: '' },
	},
	data() {
		return {
			isRegistrant: false,
			isMassUploading: false,
			massUploadMessage: '',
			needRegisterLoyalty: false,
		};
	},
	computed: {
		...mapGetters({
			getAdditionalPersonsCount: 'checkout/getAdditionalPersonsCount',
			getIsRegistrant: 'checkout/getIsRegistrant',
			getSignerPersonNumber: 'checkout/getSignerPersonNumber',
			getIsRegistrantDisclaimerDisplayed: 'checkout/getIsRegistrantDisclaimerDisplayed',
		}),
		showRegistrantError() {
			return this.$store.getters['checkout/getAdditionalPersonsCount'](this.formData.id) === 0
				&& this.$store.getters['checkout/getIsRegistrant'](this.formData.id);
		},
		showLoyaltyCheckbox() {
			return this.$store.getters['checkout/getAdditionalPersonsCount'](this.formData.id) > 0
				|| !(this.$auth.user && this.$auth.user.loyalty_id);
		},
	},
	mounted() {
		this.isRegistrant = this.getIsRegistrant(this.formData.id);
		this.$nextTick(() => {
			if (this.isValid !== null) {
				this.checkValidation();
			}
		});
	},
	methods: {
		async setLoyalty(val) {
			await this.$store.commit(
				`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_META_DATA}`,
				{
					meta: { needRegisterLoyalty: val },
					formId: this.formData.id,
				},
			);
		},
		async setRegistrantStatus(value) {
			let meta = {
				isRegistrant: value,
			};

			if (!this.getIsRegistrantDisclaimerDisplayed(this.formData.id)) {
				this.$bvModal.show('registrant-disclaimer');
				meta = { ...meta, isRegistrantDisclaimerDisplayed: true };
			}

			if (value && this.getSignerPersonNumber(this.formData.id) === 1) {
				meta = { ...meta, signerPersonNumber: null };
			}

			await this.$store.commit(
				`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_META_DATA}`,
				{
					meta,
					formId: this.formData.id,
				},
			);

			await this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`,
				{ formId: this.formData.id },
			);

			await this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_GET_PRICE_DATA}`,
				{ formId: this.formData.id },
			);
		},
		async massUpload(event) {
			this.isMassUploading = true;
			const formData = new FormData();
			formData.append('mass-upload', event.target.files[0]);
			formData.append('formId', this.formData.id);
			formData.append('uniqueId', this.$store.state.uniqueId.uniqueId);
			formData.append('need_register_loyalty', this.need_register_loyalty);
			let response = null;
			try {
				response = await this.$api.massUpload(formData).catch(((reason) => {
					this.massUploadMessage = 'Произошла ошибка сервера. Попробуйте позже.';
				}));
			} catch (exception) {
				this.massUploadMessage = 'Произошла ошибка сети. Попробуйте позже.';
			}

			if (response) {
				this.massUploadMessage = response.message;
			}

			await this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SYNC_FROM_BACKEND}`,
				{ form: this.formData, product: this.product },
			);

			this.$bvModal.show('mass-upload-message');

			this.isMassUploading = false;
		},
	},
};
</script>
